import { render, staticRenderFns } from "./form_0901.vue?vue&type=template&id=0f05844b"
import script from "./form_0901.vue?vue&type=script&lang=js"
export * from "./form_0901.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports